var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPageLoaded),expression:"isPageLoaded"}],staticClass:"onrr-feedback-form",attrs:{"id":"touchpoints-yes-no-form"}})}
var staticRenderFns = []

export { render, staticRenderFns }